import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './services/login.service';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {

  constructor(private router: Router,
    private loggedIn: LoginService) { }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!sessionStorage.getItem('token')) {
      this.router.navigate(['/login'])
      return false
    }

    return this.loggedIn.loggedIn({ token: sessionStorage.getItem('token') })
      .pipe(map(res => {

        if (res) {
          return res
        } else {
          this.router.navigate(['/login'])
          return res
        }

      }))

  }
  
}
